export enum NotificationBellCategory {
  activity = 'activity',
  courses = 'courses',
  services = 'services',
}

const ACTIVITY_ACTION_TYPES = new Set([
  'channel_comment',
  'channel_like',
  'prj_coauthor_add',
  'prj_coauthor_remove',
  'like',
]);

const COURSES_ACTION_TYPES = new Set([
  'lms_hw_add',
  'lms_hw_approve',
  'lms_hw_comment',
  'lms_exam_result',
  'lms_lesson_scheduled',
  'lms_exam_scheduled',
  'channel_member_add',
  'channel_member_remove',
  'channel_archive',
]);

const SERVICES_ACTION_TYPES = new Set([
  'certification_operation',
  'sendFile',
  'AIGeneration',
  'uploadedFile',
  'prj_auto_translation_complete',
  'project_banned',
  'book',
  'competition_apply_result_recieved',
  'new_promo_code_recieved',
  'team_owner_status_change',
  'team_moder_status_change',
  'gift-sent',
]);

/** Имена simple-шаблонов из сценариев колокольчика (курсы, №12–25). */
const COURSES_SIMPLE_ACTION_KEYS = new Set([
  'LmsLessonOpenAppointment',
  'LmsLessonAddSignUp',
  'LmsLessonRemoveSignUp',
  'LmsLessonTeacherRemoveSignUp',
  'LmsLessonRemoveSignUpForTeacher',
  'LmsLessonAllSlotsBooked',
  'MemberHasBeenAddedToCourse',
  'PaymentLinkToCourse',
  'UserHasBeenPaidCourse',
  'CoursePaymentCardReleased',
  'LmsModuleSuccessCopied',
  'LmsCourseSuccessCopied',
]);

/** Simple-шаблоны: активность (№48–49). */
const ACTIVITY_SIMPLE_ACTION_KEYS = new Set([
  'UserSubscribedToYou',
  'UserSubscribed',
  'NewSubscriber',
  'SubscribeToUser',
  'SubscribedAuthorPublishedProject',
  'AuthorPublishedForSubscriber',
  'AuthorPublishedProject',
]);

/** Simple-шаблоны: сервисы (юниты, промо, подарки и т.д.). */
const SERVICES_SIMPLE_ACTION_KEYS = new Set([
  'ProjectHasBeenAddedToUnit',
  'RequestProjectToTeam',
  'ProjectWasApprovedForUnit',
]);

const getActionType = (notification: any): string => {
  const actions = notification?.actions;
  if (!actions?.length) {
    return '';
  }
  return actions[0]?.type || '';
};

const getSimpleActionKey = (action: any): string => {
  const candidates = [
    action?.actionName,
    action?.name,
    action?.templateName,
    action?.notificationActionName,
    action?.entityName,
  ];

  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
};

const isCoursesSimpleKey = (key: string): boolean => {
  if (!key) {
    return false;
  }
  if (COURSES_SIMPLE_ACTION_KEYS.has(key)) {
    return true;
  }
  return key.startsWith('LmsLesson');
};

export const getNotificationCategory = (notification: any): NotificationBellCategory => {
  const type = getActionType(notification);

  if (!type && (!notification?.actions || notification.actions.length === 0)) {
    return NotificationBellCategory.courses;
  }

  if (ACTIVITY_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.activity;
  }

  if (COURSES_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.courses;
  }

  if (SERVICES_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.services;
  }

  if (type === 'simple') {
    const key = getSimpleActionKey(notification.actions[0]);
    if (isCoursesSimpleKey(key)) {
      return NotificationBellCategory.courses;
    }
    if (ACTIVITY_SIMPLE_ACTION_KEYS.has(key)) {
      return NotificationBellCategory.activity;
    }
    if (SERVICES_SIMPLE_ACTION_KEYS.has(key)) {
      return NotificationBellCategory.services;
    }
    return NotificationBellCategory.services;
  }

  return NotificationBellCategory.services;
};

export const filterNotificationsByCategory = (
  notifications: any[],
  category: NotificationBellCategory,
): any[] => notifications.filter((n) => getNotificationCategory(n) === category);

export const countUnreadInCategory = (
  notifications: any[],
  category: NotificationBellCategory,
): number =>
  notifications.filter((n) => !n?.isDelivered && getNotificationCategory(n) === category).length;
export enum NotificationBellCategory {
  activity = 'activity',
  courses = 'courses',
  services = 'services',
}

const ACTIVITY_ACTION_TYPES = new Set([
  'channel_comment',
  'channel_like',
  'prj_coauthor_add',
  'prj_coauthor_remove',
  'like',
]);

const COURSES_ACTION_TYPES = new Set([
  'lms_hw_add',
  'lms_hw_approve',
  'lms_hw_comment',
  'lms_exam_result',
  'lms_lesson_scheduled',
  'lms_exam_scheduled',
  'channel_member_add',
  'channel_member_remove',
  'channel_archive',
]);

const SERVICES_ACTION_TYPES = new Set([
  'certification_operation',
  'sendFile',
  'AIGeneration',
  'uploadedFile',
  'prj_auto_translation_complete',
  'project_banned',
  'book',
  'competition_apply_result_recieved',
  'new_promo_code_recieved',
  'team_owner_status_change',
  'team_moder_status_change',
  'gift-sent',
]);

/** Имена simple-шаблонов из сценариев колокольчика (курсы, №12–25). */
const COURSES_SIMPLE_ACTION_KEYS = new Set([
  'LmsLessonOpenAppointment',
  'LmsLessonAddSignUp',
  'LmsLessonRemoveSignUp',
  'LmsLessonTeacherRemoveSignUp',
  'LmsLessonRemoveSignUpForTeacher',
  'LmsLessonAllSlotsBooked',
  'MemberHasBeenAddedToCourse',
  'PaymentLinkToCourse',
  'UserHasBeenPaidCourse',
  'CoursePaymentCardReleased',
  'LmsModuleSuccessCopied',
  'LmsCourseSuccessCopied',
]);

/** Simple-шаблоны: активность (№48–49). */
const ACTIVITY_SIMPLE_ACTION_KEYS = new Set([
  'UserSubscribedToYou',
  'UserSubscribed',
  'NewSubscriber',
  'SubscribeToUser',
  'SubscribedAuthorPublishedProject',
  'AuthorPublishedForSubscriber',
  'AuthorPublishedProject',
]);

/** Simple-шаблоны: сервисы (юниты, промо, подарки и т.д.). */
const SERVICES_SIMPLE_ACTION_KEYS = new Set([
  'ProjectHasBeenAddedToUnit',
  'RequestProjectToTeam',
  'ProjectWasApprovedForUnit',
]);

const getActionType = (notification: any): string => {
  const actions = notification?.actions;
  if (!actions?.length) {
    return '';
  }
  return actions[0]?.type || '';
};

const getSimpleActionKey = (action: any): string => {
  const candidates = [
    action?.actionName,
    action?.name,
    action?.templateName,
    action?.notificationActionName,
    action?.entityName,
  ];

  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }

  return '';
};

const isCoursesSimpleKey = (key: string): boolean => {
  if (!key) {
    return false;
  }
  if (COURSES_SIMPLE_ACTION_KEYS.has(key)) {
    return true;
  }
  return key.startsWith('LmsLesson');
};

export const getNotificationCategory = (notification: any): NotificationBellCategory => {
  const type = getActionType(notification);

  if (!type && (!notification?.actions || notification.actions.length === 0)) {
    return NotificationBellCategory.courses;
  }

  if (ACTIVITY_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.activity;
  }

  if (COURSES_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.courses;
  }

  if (SERVICES_ACTION_TYPES.has(type)) {
    return NotificationBellCategory.services;
  }

  if (type === 'simple') {
    const key = getSimpleActionKey(notification.actions[0]);
    if (isCoursesSimpleKey(key)) {
      return NotificationBellCategory.courses;
    }
    if (ACTIVITY_SIMPLE_ACTION_KEYS.has(key)) {
      return NotificationBellCategory.activity;
    }
    if (SERVICES_SIMPLE_ACTION_KEYS.has(key)) {
      return NotificationBellCategory.services;
    }
    return NotificationBellCategory.services;
  }

  return NotificationBellCategory.services;
};

export const filterNotificationsByCategory = (
  notifications: any[],
  category: NotificationBellCategory,
): any[] => notifications.filter((n) => getNotificationCategory(n) === category);

export const countUnreadInCategory = (
  notifications: any[],
  category: NotificationBellCategory,
): number =>
  notifications.filter((n) => !n?.isDelivered && getNotificationCategory(n) === category).length;
